import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, model } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Product } from '../../../../generated/generated-types';
import { CustomerProductPriceEditWidgetComponent } from '../customer-product-price-edit-widget/customer-product-price-edit-widget.component';

@Component({
  selector: 'app-formly-customer-product-price-edit',
  templateUrl: './formly-customer-product-price-edit.component.html',
  standalone: true,
  imports: [
    CustomerProductPriceEditWidgetComponent,
    TranslatePipe,
    CommonModule,
  ]
})
export class FormlyCustomerProductPriceEditComponent extends FieldType {

  product = model<Product>(null);
  destroyRef = inject(DestroyRef);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.product.set(this.model);
    this.form?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.product.set(this.model);
    });
  }

}